import { FAIcon, Theme, SearchDataStructure, AttributeTypes } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';
import { dateTimeToCustomFormat, formatDateDMYYYY } from '../../../ui/utils';
export interface CoachData {
  recId: number;
  aboId: string;
  campaignId: string;
  campaignName: string;
  coachId: string | null;
  cumulativePoint: {
    point: string;
    pointAdj: string;
    lastUpdateDate?: string;
  };
  directLeader: number;
  directLeaderName: string;
  directLeaderPin: string;
  endDate: string;
  enrollmentDate: string;
  enrollmentType: string;
  name: string;
  newAboCount: {
    point: string;
    pointAdj: string;
    lastUpdateDate?: string;
  };
  newGroupAboCount: {
    point: string;
    pointAdj: string;
    lastUpdateDate?: string;
  };
  pin: string;
  remark: string;
  status: string;
  totalTeams: number;
  campaignStatRecId: string;
  pointRemark?: string;
  totalPoint?: string;
  totalPersonalSponsor?: string;
  totalGroupSponsor?: string;
  teams: {
    teamId: string;
    teamName: string;
    totalWeightIn: number;
    totalWeightOut: number;
    totalPoint: number;
  }[];
  rewards: {
    rewardRemarks?: string;
    rewardId?: number;
    rewardCode?: string;
    rewardName?: string;
    rewardType?: string;
    isNew?: boolean;
    redeemDate?: string;
    rewardRecId: string;
    rewardStatus?: string;
  }[];
  achievement: {
    completed: number;
    achieved: number;
    alp: number;
    sponsor: number;
  };
}

export interface MasterData {
  campaign: {
    campaignEnd?: string;
    campaignId?: string;
    campaignName?: string;
    campaignStart: string;
    recId?: number;
    status?: string;
  }[];
  reward?: {
    recId: number;
    rewardCode: string;
    rewardName: string;
  }[];
}
export interface CampaignOption {
  campaignEnd: string;
  campaignId: string;
  campaignName: string;
  campaignStart: string;
  status: string;
  title: string;
  value: string;
}

export const dataSearchOption: SearchDataStructure[] = [
  {
    name: 'Coach ID',
    key: 'coachId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Coach Name',
    key: 'name',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Coach ABO ID',
    key: 'aboId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
];

export const getCoachListConfig: GetColumnsType = (
  styles: Object,
  translation: Function,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'coachId',
    text: translation('admin.generalCoach.coachId'),
    width: 2,
    sortable: true,
    render: (object: DynamicObjectInterface) => <span>{object.coachId}</span>,
  },
  {
    key: 'coachName',
    text: translation('admin.generalCoach.coachName'),
    sortable: true,
    width: 4,
    render: (object: DynamicObjectInterface) => <span>{object.name}</span>,
  },
  {
    key: 'aboId',
    text: translation('admin.generalCoach.aboId'),
    sortable: true,
    width: 2,
    render: (object: DynamicObjectInterface) => <span>{object.aboId}</span>,
  },
  // {
  //   key: 'enrollmentDate',
  //   text: translation('admin.generalCoach.period'),
  //   sortable: true,
  //   width: 4,
  //   render: (object: DynamicObjectInterface) => (
  //     <span>
  //       {object.enrollmentDate && object.endDate
  //         ? `${dateTimeToCustomFormat(object.enrollmentDate?.toString(), 'MMM YYYY')} - ${dateTimeToCustomFormat(
  //             object.endDate?.toString(),
  //             'MMM YYYY',
  //           )}`
  //         : ''}
  //     </span>
  //   ),
  // },
  {
    key: 'totalTeams',
    text: translation('admin.generalCoach.totalTeams'),
    sortable: true,
    width: 3,
    render: (object: DynamicObjectInterface) => <span>{object.totalTeams}</span>,
  },
  {
    key: 'completedCount',
    text: translation('admin.generalCoach.completedCount'),
    sortable: true,
    width: 2,
    render: (object: DynamicObjectInterface) => <span>{object.completedCount}</span>,
  },
  {
    key: 'achievedCount',
    text: translation('admin.generalCoach.achievedCount'),
    sortable: true,
    width: 2,
    render: (object: DynamicObjectInterface) => <span>{object.achievedCount}</span>,
  },
  {
    key: 'ALPCount',
    text: translation('admin.generalCoach.ALPCount'),
    sortable: true,
    width: 2,
    render: (object: DynamicObjectInterface) => <span>{object.ALPCount}</span>,
  },
  {
    key: 'totalPersonalSponsor',
    text: translation('admin.generalCoach.personalSponsor'),
    sortable: true,
    width: 4,
    render: (object: DynamicObjectInterface) => <span>{object.totalPersonalSponsor}</span>,
  },
  {
    key: 'qualified',
    text: translation('admin.generalCoach.qualified'),
    sortable: true,
    width: 4,
    render: (object: DynamicObjectInterface) => <span>{object.qualified ? 'YES' : 'NO'}</span>,
  },
  {
    key: 'action-func',
    width: 1,
    text: 'Action',
    render: (object: DynamicObjectInterface) => (
      <FAIcon
        iconName={'edit'}
        onClick={e => {
          cb?.onEdit(object);
          e.stopPropagation();
        }}
        theme={Theme.PURPLE}
        title={'Edit'}
      />
    ),
  },
];

type ICoachBO = {
  [key: string]: DynamicObjectInterface;
};

export const getRewardListConfig: GetColumnsType = (
  styles: Object,
  translation: Function,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'rewardName',
    text: translation('admin.rewardMaster.rewardName'),
    sortable: true,
    width: 5,
    render: (object: ICoachBO) => <span>{object.rewardName}</span>,
  },
  {
    key: 'redeemDate',
    text: translation('admin.participant.collectDate'),
    sortable: true,
    width: 5,
    render: (object: ICoachBO) => (
      <span>{object.redeemDate ? formatDateDMYYYY(new Date(object.redeemDate)) : null}</span>
    ),
  },
];

export const getTeamListConfig: GetColumnsType = (
  styles: Object,
  translation: Function,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'teamName',
    text: 'Team Name',
    sortable: true,
    width: 5,
    render: (object: ICoachBO) => <span>{object?.teamName}</span>,
  },
  {
    key: 'period',
    text: 'Period',
    sortable: true,
    width: 6,
    render: (object: ICoachBO) => (
      <span>
        {object?.teamStartDate
          ? dateTimeToCustomFormat(object?.teamStartDate?.toString() ?? '', 'DD/MM/yyyy') +
            ' - ' +
            dateTimeToCustomFormat(object?.teamEndDate?.toString() ?? '', 'DD/MM/yyyy')
          : ''}
      </span>
    ),
  },
  {
    key: 'registerCount',
    text: 'Registered',
    sortable: true,
    width: 3,
    render: (object: ICoachBO) => <span>{object?.registerCount ?? 0}</span>,
  },
  {
    key: 'completedCount',
    text: 'Completed',
    sortable: true,
    width: 3,
    render: (object: ICoachBO) => <span>{object?.completedCount ?? 0}</span>,
  },
  {
    key: 'achievedCount',
    text: 'Achieved',
    sortable: true,
    width: 3,
    render: (object: ICoachBO) => <span>{object?.achievedCount ?? 0}</span>,
  },
  {
    key: 'ALPCount',
    text: 'SOP',
    sortable: true,
    width: 3,
    render: (object: ICoachBO) => <span>{object?.ALPCount ?? 0}</span>,
  },
  {
    key: 'action-func',
    width: 1,
    text: 'Action',
    render: (object: ICoachBO) => (
      <FAIcon
        iconName={'edit'}
        onClick={e => {
          cb?.onEdit(object);
          e.stopPropagation();
        }}
        theme={Theme.PURPLE}
        title={'Edit'}
      />
    ),
  },
];
